<template>
  <div class="home">
    <div>
      <!-- cycle -->
      <v-carousel v-model="model" show-arrows-on-hover height="auto">
        <!-- 11111111111111111111111111111111111111111111111111111111111111111 -->
        <v-carousel-item src="@/assets/bg1.jpg">
          <v-sheet style="background-color: unset;" height="100%" tile>
            <v-container class="home">
              <v-row class="mt-6" justify="center">
                <v-col
                  sm4
                  md4
                  class="d-flex flex-column justify-center right-col align-center home-img-col"
                >
                  <img
                    class="couple"
                    src="@/assets/couple-dancing.png"
                    alt="Couple dancing illustration"
                  />
                </v-col>
                <v-col
                  sm8
                  md8
                  class="d-flex flex-column justify-center mx-6 left-col text-left"
                >
                  <h1 class="main-heading white--text">
                    Social Health Connector
                  </h1>
                  <p class="mb-8 white--text supporting-text">
                    Self-assess your level of social isolation.
                    <br />
                    Get personlized recommendations.
                    <br />
                    Enroll in programs and resources available nationwide.
                  </p>
                  <router-link to="/assessment" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-assessment-page',
  eventLabel: 'main-cta'
})">
                    <v-btn
                      aria-label="Take the assessment button"
                      x-large
                      color="amber darken-1 black--text"
                      class="font-weight-bold"
                      >Take the Assessment
                      <v-icon class="pl-4" title="Take the assessment"
                        >mdi-arrow-right</v-icon
                      ></v-btn
                    >
                  </router-link>
                </v-col>
              </v-row>
              <v-row class="mt-6" justify="center"> </v-row>
            </v-container>
          </v-sheet>
        </v-carousel-item>
                <!-- 2222222222222222222222222222222222222222222222222222222222222222222222222222222222222222 -->

        <v-carousel-item src="@/assets/bg4-flipped.jpg">
          <v-sheet style="background-color: unset;" height="100%" tile>
            <v-container class="home">
              <v-row class="mt-6" justify="center">
                <v-col
                  sm4
                  md4
                  class="d-flex flex-column justify-center right-col align-center home-img-col"
                >
                  <!-- <img
                    class="couple"
                    src="@/assets/partners-white.png"
                    alt="Challenge Partner Logos"
                  /> -->
                </v-col>
                <v-col
                  sm8
                  md8
                  class="d-flex flex-column justify-center mx-6 left-col text-left"
                >
                  <h1 class="main-heading">
                    Try our video assessment.
                  </h1>
                  <p class="mt-8 mb-8 supporting-text">
                    Our Video Assessment offers an alternative for users who find that an interactive self-assessment is either more engaging or accessible for their needs.
                  </p>
                  <router-link to="/VideoAsk" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-VideoAsk-page',
  eventLabel: 'another-cta'
})">
                    <v-btn
                      aria-label="Learn About Our Team"
                      x-large
                      color="blue lighten-1"
                      class="font-weight-bold"
                      >Take the Video Assessment
                      <v-icon class="pl-4" title="VideoAsk Assessment"
                        >mdi-arrow-right</v-icon
                      ></v-btn
                    >
                  </router-link>
                </v-col>
              </v-row>
              <v-row class="mt-6" justify="center"> </v-row>
            </v-container>
          </v-sheet>
        </v-carousel-item>
        <!-- 2222222222222222222222222222222222222222222222222222222222222222222222222222222222222222 -->
        <v-carousel-item src="@/assets/bg2.jpg">
          <v-sheet style="background-color: unset;" height="100%" tile>
            <v-container class="home">
              <v-row class="mt-6" justify="center">
                <v-col
                  sm4
                  md4
                  class="d-flex flex-column justify-center right-col align-center home-img-col"
                >
                  <img
                    class="couple"
                    src="@/assets/acl-white.png"
                    alt="ACL logo"
                  />
                </v-col>
                <v-col
                  sm8
                  md8
                  class="d-flex flex-column justify-center mx-6 left-col text-left"
                >
                  <h1 class="main-heading">
                    Phase 1 Winner
                  </h1>
                  <p class="mt-8 mb-8 supporting-text">
                    ACL seeks solutions to match people who are socially
                    isolated with available social engagement programs and
                    technology solutions.
                    <a
                      href="https://acl.gov/MENTAL"
                      style="text-decoration:underline;"
                      class="white--text"
                    >
                      Read more about the M.E.N.T.A.L. Health Innovation
                      Challenge here
                    </a>
                  </p>
                  <a
                    aria-label="Link to Challenge description"
                    href="https://acl.gov/MENTAL/Phase1winners"
                  >
                    <v-btn
                      aria-label="View the press release"
                      x-large
                      color="green darken-3"
                      class="font-weight-bold"
                      >View the press release
                      <v-icon class="pl-4" title="View the press release"
                        >mdi-arrow-right</v-icon
                      ></v-btn
                    >
                  </a>
                </v-col>
              </v-row>
              <v-row class="mt-6" justify="center"> </v-row>
            </v-container>
          </v-sheet>
        </v-carousel-item>
        <!-- 333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333 -->
        <v-carousel-item src="@/assets/bg3.jpg">
          <v-sheet style="background-color: unset;" height="100%" tile>
            <v-container class="home">
              <v-row class="mt-6" justify="center">
                <v-col
                  sm4
                  md4
                  class="d-flex flex-column justify-center right-col align-center home-img-col"
                >
                  <img
                    class="couple"
                    src="@/assets/partners-white.png"
                    alt="Challenge Partner Logos"
                  />
                </v-col>
                <v-col
                  sm8
                  md8
                  class="d-flex flex-column justify-center mx-6 left-col text-left"
                >
                  <h1 class="main-heading">
                    DARS, SeniorNavigator, and VCU Gerontology
                  </h1>
                  <p class="mt-8 mb-8 supporting-text">
                    Partnered together to bring you this innovative solution. To
                    make best use of this site, please take our Holst-Lunstad
                    inspired Assessment.
                  </p>
                  <router-link to="/about" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-about-page',
  eventLabel: 'another-cta'
})">
                    <v-btn
                      aria-label="Learn About Our Team"
                      x-large
                      color="blue lighten-1"
                      class="font-weight-bold"
                      >Learn about our Team
                      <v-icon class="pl-4" title="About our team"
                        >mdi-arrow-right</v-icon
                      ></v-btn
                    >
                  </router-link>
                </v-col>
              </v-row>
              <v-row class="mt-6" justify="center"> </v-row>
            </v-container>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
    <HomeGrid class="mt-12" />
    <div class="second-cta pb-12 pt-12 mt-12">
      <v-col sm8 md8 class="d-flex flex-column justify-center mx-6 text-center">
        <h1 class="black--text">
          Have you been assessed yet?
        </h1>
        <p class="mt-8 mb-8 black--text">
          In under <b>10</b> minutes you can:
          <br />
          Self-assess your level of social isolation.
          <br />
          Get personlized recommendations.
          <br />
          Enroll in programs and resources available nationwide.
        </p>
        <router-link to="/assessment" @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-assessment-page',
  eventLabel: 'bottom-cta'
})">
          <v-btn
            aria-label="Take the assessment button"
            x-large
            color="amber darken-1 black--text"
            class="font-weight-bold"
            >Take the Assessment
            <v-icon class="pl-4" title="Take the assessment">mdi-arrow-right</v-icon></v-btn
          >
        </router-link>
      </v-col>
    </div>
  </div>
</template>

<script>
import HomeGrid from '../components/HomeGrid';

export default {
  name: 'Home',
  components: {
    HomeGrid,
  },
  data() {
    return {
      model: 0,
    };
  },
  created() {
    window.VIDEOASK_EMBED_CONFIG = {
      kind: 'widget',
      url: 'https://www.videoask.com/foxvfs2n0',
      options: {
        widgetType: 'VideoThumbnailExtraLarge',
        text: 'Take our video assessment',
        backgroundColor: '#FFB300',
        position: 'bottom-right',
      },
    };
  },
};
</script>

<style scoped>
.main-heading {
  font-family: 'Baloo Da 2', cursive !important;

  font-size: 3rem;
}

.couple {
  width: 15rem;
}

.second-cta {
  background-color: #f1f1f1;
}

.supporting-text {
  font-size: 1.1rem;
  line-height: 1.7rem;
}

@media screen and (max-width: 654px) {
  .home-img-col {
    display: none !important;
  }
}
</style>
